import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgCalendar = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.62671 7.125C2.62671 6.02043 3.52214 5.125 4.62671 5.125H19.3767C20.4813 5.125 21.3767 6.02043 21.3767 7.125V19.375C21.3767 20.4796 20.4813 21.375 19.3767 21.375H4.62671C3.52214 21.375 2.62671 20.4796 2.62671 19.375V7.125Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.62671 10.125H21.3767"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.62671 6.005V3.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3767 6.005V3.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgCalendar.displayName = 'SvgCalendar';
export default SvgCalendar;
